import _ from 'lodash'
import {ORGANIZATION_SET, USER_REQUEST} from '../_store'
import { choosePluralForm } from '../i18n/pluralization'
import eventBus from './eventBus'

let language = 'en'

export default {
    methods: {
        notify (type, text, duration = 10000) {
            if (typeof text !== 'string' || text.length === 0) {
                text = 'Unknown error'
            }
            if (text.indexOf('message.') === 0) {
                text = this.$t(text)
            }
            this.$b_notify({
                type: type,
                content: text,
                duration: duration
            })
        },
        getErrorMessage (error) {
            if (error && error.response && error.response.data) {
                const data = error.response.data
                if (typeof data === 'string') {
                    const trimmed = data.trim()
                    if (trimmed.charAt(0) === '<' || /<!DOCTYPE/i.test(trimmed) || /<html/i.test(trimmed)) {
                        return 'Unknown error'
                    }
                    return data
                }
                if (data.message) {
                    return data.message
                }
                if (data.error) {
                    return data.error
                }
            }
            return error && error.message ? error.message : 'Unknown error'
        },
        translateForm (schema) {
            if (!_.isArray(schema)) {
                schema = [schema]
            }
            schema.forEach(item => {
                for (let i in item.i18n) {
                    const tr = item.i18n[i]
                    item[i] = _.isFunction(tr) ? tr() : this.$t(tr)
                }
                if (item.fields || item.groups || item.values) {
                    this.translateForm(item.fields || item.groups || item.values)
                }
            })
        },
        isCheckedValidator (value, field, model) {
            if (field.isValue === undefined) {
                return ['invalid field schema, missing `isValue` property']
            }
            if (field.requiredValue === undefined) {
                return ['invalid field schema, missing `requiredValue` property']
            }
            let a = model[field.isValue]
            let b = field.requiredValue
            if (value === '' && a === b) {
                return ['Field is required.']
            }
            return []
        },
        isCheckedValidator2 (value, field, model) {
            if (field.isChecked === undefined) {
                return ['invalid field schema, missing `isChecked` property']
            }
            let a = model[field.isChecked]
            if (value && a) {
                return ['Nemohou být skryty oba vysílače.']
            }
            return []
        },
        validEmail (email) {
            // const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return re.test(email)
        },
        getLanguage () {
            return language
        },
        encodeITN(itnDec) {
            if (itnDec < 0 || itnDec > 99999999) {
                throw new Error("Mimo rozsah ITN");
            }

            // přičtení offsetu 0x40 do nejvyššího bytu
            const uniq = itnDec + (0x40 << 24);

            // převod na 8místný HEX string
            return uniq.toString(16).toUpperCase().padStart(8, "0");
        },
        heatUnitChoice (value) {
            const rounded = Math.round(value * 100) / 100
            if (rounded % 1 !== 0) {
                return 5
            }
            return Math.abs(Math.round(rounded))
        },
        heatUnitLabel (value) {
            const choice = this.heatUnitChoice(value)
            const forms = this.$t('message.heat_unit').split('|').map(form => form.trim())
            return choosePluralForm(forms, choice)
        },
        decodeITN(uniqHex) {
            if (typeof uniqHex !== 'string') {
                return null
            }

            // uniqHex jako string např. "40A1B2C3", "40 A1 B2 C3" nebo "40-A1B2C3"
            uniqHex = uniqHex.replace(/[\s-]+/g, '')
            if (!/^[0-9A-Fa-f]{8}$/.test(uniqHex)) {
                return null
            }

            const value = parseInt(uniqHex, 16)

            // vytáhni nejvyšší byte (DEVID)
            const devid = (value >>> 24) & 0xFF

            // kontrola rozsahu ITN
            if (devid < 0x40 || devid > 0x45) {
                return null // není ITN
            }

            // odmaskování (odečtení 0x40 << 24)
            const originalValue = value - (0x40 << 24)
            if (originalValue < 0 || originalValue > 99999999) {
                return null
            }

            // převod na DEC (číslo ze štítku)
            return originalValue
        }
    },
    computed: {
        activeOrganization: {
            get () {
                return this.$store.getters.activeOrganization
            },
            set (organization) {
                this.$store.commit(ORGANIZATION_SET, organization)
                this.init()
            }
        },
        availableOrganizations () {
            return this.$store.getters.availableOrganizations
        },
        activeUser () {
            return this.$store.getters.activeUser
        },
        isAuthenticated () {
            return this.$store.getters.isAuthenticated
        },
        loadUser () {
            this.$store.dispatch(USER_REQUEST, {action: 'read'})
        },
        showUnit: {
            get () {
                const user = this.$store.getters.activeUser
                return user && user.showUnit ? user.showUnit : 'liters'
            },
            set (unit) {
                this.$store.dispatch(USER_REQUEST, {
                    showUnit: unit,
                    action: 'create'
                })
            }
        },
        isUserOwnerOfActiveOrganization () {
            const active = this.activeOrganization
            const available = this.availableOrganizations
            if (!active) {
                return false
            }
            for (let i of available) {
                if (i.id === active.id) {
                    return i.owner
                }
            }
            return false
        }
    },
    created () {
        language = this.$store.getters.language
        this.stopMixinLanguageListener = eventBus.on('language', (e) => {
            language = e
            if (this.schema) {
                this.translateForm(this.schema)
            }
        })
        if (this.schema) {
            this.translateForm(this.schema)
        }
    },
    beforeUnmount () {
        this.stopMixinLanguageListener()
    }
}
